import React from "react";
import { NavLink } from "react-router-dom";
import { useConfig } from "../context/ConfigContext.jsx";
import { ROUTES, isRouteEnabled } from "../../app/routeConfig.js";

export function BottomNav() {
  const config = useConfig();
  const features = config?.features || {};
  const visibleTabs = ROUTES.filter((route) => !route.hideInNav && isRouteEnabled(route, features));

  return (
    <nav className="bottom-nav">
      {visibleTabs.map((tab) => (
        <NavLink
          key={tab.id}
          to={tab.path}
          end={tab.path === "/"}
          className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}
        >
          <span className="nav-icon">{tab.icon}</span>
          <span>{tab.label}</span>
        </NavLink>
      ))}
    </nav>
  );
}

export default BottomNav;
